import {FC, useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider, useLayout} from './core'
import {ActivityDrawer, DrawerMessenger, InviteUsers, RightToolbar, UpgradePlan} from '../partials'
import {
  ThemeModeProvider,
  themeModeSwitchHelper,
  useThemeMode,
} from '../partials/layout/theme-mode/ThemeModeProvider'
import {MenuComponent} from '../../_handld/assets/ts/components'
import clsx from 'clsx'
import {WithChildren} from '../helpers'
import {Toolbar} from './components/toolbar/Toolbar'
import {DrawerBecomeHandlr} from '../partials/layout/become-handlr/DrawerBecomeHandlr'
import moment from 'moment'
import preval from 'preval.macro'

const MasterLayout: FC<WithChildren> = ({children}) => {
  const {classes} = useLayout()
  const {mode} = useThemeMode()
  const location = useLocation()
  const {pathname} = window.location
  const handleContainer = () => {
    if (
      pathname.includes('landing') ||
      pathname.includes('services') ||
      pathname.includes('faq') ||
      pathname.includes('About-us') ||
      pathname.includes('Contact-us') ||
      pathname.includes('become-a-handyman')
    ) {
      return true
    }

    return false
  }

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  useEffect(() => {
    themeModeSwitchHelper(mode)
  }, [mode])

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='page d-flex flex-row flex-column-fluid'>
          <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
            <HeaderWrapper />

            <div id='kt_content' className='content d-flex flex-column flex-column-fluid pb-10'>
              {handleContainer() ? '' : <Toolbar />}
              <div
                className={clsx(
                  'd-flex flex-column-fluid align-items-start',
                  handleContainer() ? 'container-fluid' : classes.contentContainer.join(' ')
                )}
                id='kt_post'
              >
                <AsideDefault />
                <Content>
                  <Outlet />
                </Content>
              </div>
            </div>

            {pathname.includes('backoffice') ? (
              <small className='mx-5 mb-3 px-5'>
                Build Version <strong>{process.env.REACT_APP_VERSION}</strong> / Build Date:{' '}
                <strong>
                  {moment(preval`module.exports = new Date().toLocaleDateString("en-US");`).format(
                    'MM/DD/YYYY'
                  )}
                </strong>
              </small>
            ) : (
              <Footer />
            )}
          </div>
        </div>

        {/* begin:: Drawers */}
        <ActivityDrawer />
        {/* <RightToolbar /> */}
        <DrawerMessenger />
        {/* <DrawerBecomeHandlr /> */}
        {/* end:: Drawers */}

        {/* begin:: Modals */}
        <InviteUsers />
        <UpgradePlan />
        {/* end:: Modals */}
        <ScrollTop />
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export {MasterLayout}
